import PropTypes from "prop-types";
import React from "react";
import "./ButtonGroup.css";

const ButtonGroup = props => {
	const { children, direction, orientation } = props;
	return (
		<div
			className={`ButtonGroup ButtonGroup-${direction} ButtonGroup-${orientation}`}
		>
			{children}
		</div>
	);
};

ButtonGroup.propTypes = {
	direction: PropTypes.oneOf(["vertical", "horizontal"]),
	orientation: PropTypes.oneOf(["left", "right", "center"])
};

ButtonGroup.defaultProps = {
	direction: "horizontal",
	orientation: "center"
};

export default ButtonGroup;
